export const isIos = !(navigator.userAgent.match(/iPhone|iPad|iPod/i) === null);
